(function(){
  if(window.__apolloSciInitDone){ return; }
  function __apolloSciInit(){
    if(window.__apolloSciInitDone){ return; }
    window.__apolloSciInitDone = true;

(function(){
  var scope = document;

  // FAQ accordions
  scope.querySelectorAll('.hs-faq-item').forEach(function(item){
    var btn = item.querySelector('.hs-faq-q');
    var sign = item.querySelector('.hs-faq-sign');
    if(!btn) return;
    btn.addEventListener('click', function(){
      var open = item.classList.toggle('hs-open');
      btn.setAttribute('aria-expanded', open ? 'true':'false');
      if(sign) sign.textContent = open ? '\u2013' : '+';
      // close siblings in same list
      var list = item.parentElement;
      if(open && list){
        list.querySelectorAll('.hs-faq-item.hs-open').forEach(function(o){
          if(o!==item){ o.classList.remove('hs-open'); var b=o.querySelector('.hs-faq-q'); var sg=o.querySelector('.hs-faq-sign'); if(b)b.setAttribute('aria-expanded','false'); if(sg)sg.textContent='+'; }
        });
      }
    });
  });

  // Interactive learn-more cards (click / keyboard toggle)
  scope.querySelectorAll('[data-hs-lm]').forEach(function(card){
    var toggle = function(){
      var opening = !card.classList.contains('hs-open');
      var grid = card.closest('.hs-lm-grid');
      if(opening && grid){
        grid.querySelectorAll('[data-hs-lm].hs-open').forEach(function(other){
          if(other !== card){
            other.classList.remove('hs-open');
            other.setAttribute('aria-expanded', 'false');
          }
        });
      }
      card.classList.toggle('hs-open', opening);
      var open = opening;
      card.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    card.addEventListener('click', toggle);
    card.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); toggle(); }
    });
  });

  // Week track mobile nav
  scope.querySelectorAll('[data-week-prev]').forEach(function(b){
    b.addEventListener('click', function(){ var t=document.getElementById('weekTrack-'+b.getAttribute('data-week-prev')); if(t) t.scrollBy({left: -Math.round(t.clientWidth*0.85), behavior:'smooth'}); });
  });
  scope.querySelectorAll('[data-week-next]').forEach(function(b){
    b.addEventListener('click', function(){ var t=document.getElementById('weekTrack-'+b.getAttribute('data-week-next')); if(t) t.scrollBy({left: Math.round(t.clientWidth*0.85), behavior:'smooth'}); });
  });

  // Product carousels prev/next
  scope.querySelectorAll('.hs-carousel-wrap').forEach(function(wrap){
    var track = wrap.querySelector('[data-hs-carousel]');
    var prev = wrap.querySelector('[data-hs-prev]');
    var next = wrap.querySelector('[data-hs-next]');
    if(!track) return;
    var step = function(){ var card = track.querySelector('.hs-pcard'); return card ? card.getBoundingClientRect().width + 18 : 280; };
    if(prev) prev.addEventListener('click', function(){ track.scrollBy({left: -step()*1.5, behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ track.scrollBy({left: step()*1.5, behavior:'smooth'}); });
  });

  // Header overlay: transparent over hero, solid after scroll
  (function(){
    if(!(window.Shopify && Shopify.designMode)){
    var hero = scope.querySelector('.hs-hero-full');
    if(hero){
      document.body.classList.add('hs-science-overlay');
      var onScroll = function(){
        var r = hero.getBoundingClientRect();
        var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nss-header-height')) || 80;
        if(r.bottom <= hh + 8){ document.body.classList.add('hs-header-solid'); }
        else { document.body.classList.remove('hs-header-solid'); }
      };
      window.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', onScroll, {passive:true});
      onScroll();
    }
    }
  })();

  // Reveal + grow + draw
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nodes = Array.prototype.slice.call(scope.querySelectorAll('[data-reveal],[data-grow],[data-draw]'));
  if(reduce || !('IntersectionObserver' in window)){
    nodes.forEach(function(n){ n.classList.add('hs-in'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('hs-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    nodes.forEach(function(n){ io.observe(n); });
  }
})();

// Science page has two page-embedded buyboxes. The canonical buybox script uses
// document-wide selectors when expanding a supply tier, so the second instance
// can collapse the first instance's active 30-day panel during initialisation.
// Re-apply expansion per buybox and keep each instance isolated after clicks.
(function(){
  if (window.__apolloScienceBuyboxPanelsBound) return;
  window.__apolloScienceBuyboxPanelsBound = true;

  function restoreActivePanels(){
    var ids = ['science-electrolytes-buybox', 'science-perform-buybox', 'science-final-buybox'];
    ids.forEach(function(id){
      var buybox = document.getElementById(id);
      if (!buybox) return;
      buybox.querySelectorAll('.js-qty-expanded').forEach(function(panel){
        panel.style.display = 'none';
      });
      var active = buybox.querySelector('.js-nss-quantity-selector.active') || buybox.querySelector('.js-nss-quantity-selector');
      if (!active) return;
      active.classList.add('active');
      var panel = active.querySelector('.js-qty-expanded');
      if (panel) panel.style.display = 'block';
    });
  }

  function bind(){
    restoreActivePanels();
    ['science-electrolytes-buybox', 'science-perform-buybox', 'science-final-buybox'].forEach(function(id){
      var buybox = document.getElementById(id);
      if (!buybox || buybox.dataset.sciencePanelsBound === '1') return;
      buybox.dataset.sciencePanelsBound = '1';
      buybox.addEventListener('click', function(event){
        if (event.target.closest('.js-nss-quantity-selector')) {
          window.setTimeout(restoreActivePanels, 0);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ window.setTimeout(bind, 0); });
  } else {
    window.setTimeout(bind, 0);
  }
})();
  }
  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", __apolloSciInit); } else { __apolloSciInit(); }
})();
